import React from 'react';
import { Activity } from 'lucide-react';
import PMT2SpreadsheetConfig from '../pmt2/PMT2SpreadsheetConfigSection';

/**
 * Admin section wrapper for PMT2 spreadsheet configuration
 */
const PMT2SpreadsheetConfigSection: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-sm dark:bg-gray-800">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="h-6 w-6 text-orange-500 dark:text-orange-400" />
        <h2 className="text-xl font-semibold dark:text-white">PMT3 Spreadsheet Configuration</h2>
      </div>
      <PMT2SpreadsheetConfig />
    </div>
  );
};

export default PMT2SpreadsheetConfigSection;